module.exports = __webpack_public_path__ + "static/media/challengeIllustration.0936b9c6.png";